import { OwnerEmpty } from "../shell/OwnerEmpty";

/**
 * Where a browser lands when an outside service sent it back with a consent the Hub could not hand to an
 * Agent (`hub/consent.py` `REFUSED_PAGE`). The Hub gives the same answer for every reason, so this does too:
 * one sentence, and the one way back.
 */
export function ConsentRefused() {
  return <OwnerEmpty icon="alert" action={<a className="btn btn-accent" href="/#/agents">回到我的 IP</a>}>
    这次授权没有交给 IP。回到原来的页面，登录后重新连接频道。
  </OwnerEmpty>;
}
